import { DollarSign } from 'lucide-react';
import { formatCurrency } from '../utils/helpers';
import type { Team } from '../types';

interface WalletCardProps {
  team: Team;
}

const WalletCard = ({ team }: WalletCardProps) => (
  <div className="bg-gradient-to-br from-slate-800 to-slate-900 text-white p-4 sm:p-6 rounded-2xl shadow-lg relative overflow-hidden">
    <div className="absolute top-0 right-0 p-4 opacity-10">
      <DollarSign className="w-24 sm:w-32 h-24 sm:h-32" />
    </div>
    <div className="relative z-10">
      <p className="text-slate-400 text-xs sm:text-sm font-medium uppercase tracking-wider mb-1">Wallet Balance</p>
      <h3 className="text-2xl sm:text-4xl font-bold mb-4">
        {formatCurrency(team.currentBalance)} <span className="text-sm sm:text-lg text-slate-400 font-normal">pts</span>
      </h3>

      <div className="grid grid-cols-2 gap-2 sm:gap-4 border-t border-slate-700 pt-4">
        <div>
          <p className="text-slate-400 text-xs">Total Budget</p>
          <p className="font-semibold text-sm sm:text-base">{formatCurrency(team.totalBudget)}</p>
        </div>
        <div>
          <p className="text-slate-400 text-xs">Spent</p>
          <p className="font-semibold text-orange-400 text-sm sm:text-base">
            {formatCurrency(team.totalBudget - team.currentBalance)}
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default WalletCard;

